import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import fetchFromElectron from '~/helpers/deviceChecks/fetchFromElectron';
import fetchFromExtension from '~/helpers/deviceChecks/fetchFromExtension';
import { DeviceCheckMetadata } from '~/types';

const checkExternalStorage: DeviceCheckMetadata['check'] = async ({
  registrationDetails,
}) => {
  try {
    const promise = window.electron
      ? fetchFromElectron('EXTERNAL_STORAGE')
      : fetchFromExtension('EXTERNAL_STORAGE');
    const result = await promise;
    const storageUnitCount = result.data?.removableStorageUnitCount;

    if (!result.data) {
      return {
        result: DeviceCheckResult.Fail,
      };
    }

    if (Number.isInteger(storageUnitCount) && storageUnitCount === 0) {
      return {
        result: DeviceCheckResult.Pass,
        value: String(storageUnitCount),
      };
    }

    throw new Error('External storage detected');
  } catch (err) {
    const e = err as Error;
    const error = new Error(
      JSON.stringify({
        error: e.message,
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    return {
      result: DeviceCheckResult.Fail,
      value: e.message,
    };
  }
};

export default checkExternalStorage;
